// extracted by mini-css-extract-plugin
export default {"button":"NumericInput_button__lj9JZ","buttonIncrease":"NumericInput_buttonIncrease__p2RhB","buttonDecrease":"NumericInput_buttonDecrease__zLWS2","input":"NumericInput_input__ez+AL"};